import './_ctx/init';
import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

const rootElement = document.getElementById('main') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
root.render(<App />);
